<template>
    <div class="container is-hidden-touch">
        <div class="logo-containers">
            <h1>Award-Winning Travel Insurance</h1>
            <p>
                Covered2Go offer highly rated, award-winning travel insurance, providing you with complete peace of mind and protection from the moment you book your trip to the moment you arrive home.
            </p>
        </div>
        <div class="logo-containers">            
            <div>
                <picture>
                    <source srcset="/img/facebook.png" type="image/png">
                    <img src="/img/facebook.png" loading="lazy" height="44" alt="Facebook rating logo">
                </picture>
            </div>
            <div>
                <picture>
                    <source srcset="/img/travel-aware.png" type="image/png">
                    <img src="/img/travel-aware.png" loading="lazy" height="44" alt="Travel aware logo">
                </picture> 
            </div>
            <div>
                <picture>
                    <source srcset="/img/defaqto.png" type="image/png">
                    <img src="/img/defaqto.png" loading="lazy" height="44" alt="Defaqto Expert rated logo">
                </picture> 
            </div>
            <!-- TrustPilot -->
            <div class="tp-item">
                <div class="trustpilot-widget" data-locale="en-GB" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="50b7a9eb00006400051f090e" data-style-height="50px" data-style-width="100%" data-theme="light">
                    <a href="https://uk.trustpilot.com/review/covered2go.co.uk" target="_blank" rel="noopener">Trustpilot</a>
                </div>
            </div>
            <div>
                <picture>
                    <source srcset="/img/shortlisted.png" type="image/png">
                    <img src="/img/shortlisted.png" loading="lazy" height="44" alt="Moneyfacts shortlisted 2023">
                </picture>
            </div>
            <div>
                <picture>
                    <source srcset="/img/ICA-finalist.png" type="image/png">
                    <img src="/img/ICA-finalist.png" loading="lazy" height="44" alt="Insurance choice awards finalist 2017">
                </picture>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'HomeAwardLogos',
      data() {
        return {};
      },
      mounted() {},
    };
</script>

<style lang="scss" scoped>

  h1 {
    color: $c2g_blue;
    font-size: 2em;
    margin: 10px;
    font-weight: 600;
    line-height: 1.125;
  }

  p {
    text-align: center;
  }

  .logo-containers {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
  }


  .level {
    margin-bottom: 12px;
  }
</style>